import { SectionHead, Reveal } from "./Reveal";
import { Calculator } from "./Calculator";
import { PriceList } from "./PriceList";
import { useLang } from "../../lib/i18n";

export const Pricing = ({ pricing, classes }) => {
  const { t } = useLang();
  return (
    <section id="rates" className="mx-auto max-w-[1440px] px-5 py-24 lg:px-10 lg:py-32" data-testid="pricing-section">
      <SectionHead index="02" eyebrow={t.ratesEyebrow} title={<>{t.ratesTitle[0]}<br />{t.ratesTitle[1]}</>}>
        {t.ratesText}
      </SectionHead>
      <div className="grid items-start gap-6 lg:grid-cols-12">
        <div className="lg:col-span-7"><PriceList classes={classes} pricing={pricing} /></div>
        <Reveal className="lg:col-span-5" delay={0.1}><Calculator pricing={pricing} classes={classes} /></Reveal>
      </div>
    </section>
  );
};
